import { render, staticRenderFns } from "./ResetPasswordBox.vue?vue&type=template&id=1117854d&"
import script from "./ResetPasswordBox.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports